module.exports = __webpack_public_path__ + "img/app-logo.01de455e.png";